<template>
  <div class="page">
    <div class="topFixed" :class="!isShowTopFixed ? 'topFixedHide' : ''">
      <span class="logoImg" :class="hideScale.includes('logoImg') ? 'hideSclan' : ''"></span>
      <img class="logotext" src="@/image/logoTxt.png" alt="" :class="hideScale.includes('logotext') ? 'hideSclan' : ''">
      <img class="logoUnderline" src="@/image/logoUnderline.png" alt="" :class="hideScale.includes('logoUnderline') ? 'hideSclan' : ''">
      <div class="tabListOut" :class="hideScale.includes('tabListOut') ? 'tabListOutfix' : ''">
        <div v-for="(item, index) in tabBtn.tabList" :key="index" :class="tabBtn.tabIndex == index ? 'btnActive' : ''" @click="tabClick(index)">
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="mainInfo">
      <index_leadingProduct v-show="tabBtn.tabIndex == 0" @popupData="popupData"></index_leadingProduct>
      <index_superiorProduct v-show="tabBtn.tabIndex == 1" @popupData="popupData"></index_superiorProduct>
      <index_productSpecification v-if="tabBtn.tabIndex == 2"></index_productSpecification>
      <companyIntroduction v-if="tabBtn.tabIndex == 3"></companyIntroduction>
    </div>
    <div class="botinfo" v-show="tabBtn.tabIndex != 3">
      <img src="@/image/textData.png" class="topTxt" alt="">
    </div>
    <div class="popupOut" @touchmove.stop.prevent="touchmovestop" v-if="popupDataobj.isShow && popupDataobj.popupdata.length">
      <div class="popupMain">
        <i class="topleft"></i>
        <i class="escIcon" @click="closePopup"></i>
        <div class="mainData">
          <div>
            <span class="leftLine"></span>
          </div>
          <div class="rightView">
            <div class="boxes" v-for="(item, index) in popupDataobj.popupdata" :key="index" @click="popupClick(item.tit)">{{item.nameNew || item.tit}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup } from 'vant';
import index_leadingProduct from "@/view/compontsPage/index_leadingProduct";
import index_superiorProduct from "@/view/compontsPage/index_superiorProduct";
import index_productSpecification from "@/view/compontsPage/index_productSpecification";
import companyIntroduction from "@/view/compontsPage/companyIntroduction";
import { Shares } from '@/js/share'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    index_leadingProduct,
    index_superiorProduct,
    index_productSpecification,
    companyIntroduction,
  },
  data() {
    return {
      isShowTopFixed: true,
      sctimer: null,
      sctopInfo: {
        sctop: 0,
        lastSctop: 0,
        distance: 80,
      },
      hideScale: '',
      tabBtn: {
        tabIndex: 0,
        tabList: [
          {name: '领先产品',},
          {name: '优势产品',},
          {name: '产品总目录',},
          {name: '公司介绍',},
        ]
      },
      popupDataobj: {
        isShow: false,
        popupdata: [],
        '社会稳定风险防控治理体系' : [
          {tit: '“五盾”维稳防控工程', nameNew: '社会维稳“五盾”风险防控工程'},
          {tit: '重大决策社会稳定风险评估系统', },
          {tit: '社会维稳信息管理平台', },
        ],
        '智慧养老助残服务' : [
          {tit: '社区居家养老服务服务平台'},
          {tit: '养老机构数字化管理平台', },
          {tit: '智慧助残服务管理平台', },
        ]
      }
    }
  },
  watch: {
    'popupDataobj.isShow'(val) {
      !val ? this.$set(this.popupDataobj, 'popupdata' , []) : ''
    },
    'sctopInfo.sctop'(val) {
      clearTimeout(this.sctimer)
      console.log(val)
      if(!val) {
        this.hideScale = ''
        // this.isShowTopFixed = true
        // return
      }
      if(val>196) {
        // this.isShowTopFixed = false
        // return
      }else{
        this.hideScale = ''
        // this.isShowTopFixed = true
      }
      if(val>40) {
        this.hideScale = ''
      }
      if(val>110) {
        // this.hideScale = ',logotext,logoUnderline'
        this.hideScale = ''
      }
      if(val>168) {
        // this.hideScale = 'logoImg,tabListOut,logotext,logoUnderline'
        this.hideScale = ''
      }
      if(val>162) {
        this.hideScale = 'tabListOut'
      }else{
        this.hideScale = ''
      }
      return;
      this.sctimer = setTimeout(()=>{
        let sctop = this.sctopInfo.sctop
        let lastSctop = this.sctopInfo.lastSctop
        // let distancecompare = this.sctopInfo.distance
        this.$set(this.sctopInfo, 'lastSctop', sctop)
        const distance = Math.abs(sctop - lastSctop)
        console.log(distance, ' distance')
        // if(distance >= distancecompare) {
        // }

        if(sctop < lastSctop) {
          this.isShowTopFixed = true
        }else{
          this.isShowTopFixed = false
        }
      }, 100)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollSet);

    let imgurl = 'https://xztys.goldweb.cn/img/shareImg2.jpg'
    let title = '海盟公司产品简介'
    let desc = '专注企业数字化、政府智能化建设工程，集平台研发、智能产品、系统集成、运营服务于一体。'
    let link = 'https://xztys.goldweb.cn/#/index'
    // console.log(imgurl, title, desc, link)
    Shares.shareCode(imgurl, title, desc, link, (status,data) => {
      if(status === 'success') {
        console.log('success')// 分享成功的操作
      } else if(status === 'cancel') {
        console.log('error')// 分享失败的操作
      }
    })
  },
  methods: {
    touchmovestop() {},
    clickStop() {},
    closePopup() {
      this.$set(this.popupDataobj, 'isShow' , false)
    },
    popupData(eventData) {
      const setArr = this.popupDataobj[eventData]
      this.$set(this.popupDataobj, 'popupdata' , [...setArr])
      this.$set(this.popupDataobj, 'isShow' , true)
    },
    popupClick(item) {
      this.navigator({name: 'detail', query: {title: item}})
    },
    tabClick(index) {
      this.$set(this.tabBtn, 'tabIndex', index)
    },
    scrollSet() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.$set(this.sctopInfo, 'sctop', scrollTop)
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollSet)
  }
};
</script>

<style lang="less" scoped>
.page{
  width: 375px;
  min-height: 100vh;
  box-sizing: border-box;
  //padding-top: 199px;
  //background: url("~@/image/pageBg.png");
  background-color: #000020;
  background-image: url("~@/image/topweb.png");
  background-size: 200% 180%;
  background-repeat: repeat-y;

  background-attachment: fixed;
  background-position: 68% 20%;
  position: relative;
  .topFixed{
    width: 100%;
    height: 199px;
    //position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    transition: all .1s ease;
    background: #00002020;
    opacity: 1;
    overflow: hidden;
    .logoImg{
      width: 51px;
      height: 48px;
      background: url("~@/image/hmLogo.png") no-repeat;
      background-size: 100% 100%;
      background-position: 0 0;
      display: block;
      margin: 0 auto;
      margin-top: 34px;
      margin-bottom: 17px;
      z-index: 9;
      transition: all .1s ease;
      opacity: 1;
    }
    .logotext{
      width: 225px;
      height: 28px;
      display: block;
      margin: 0 auto;
      z-index: 9;
      transition: all .1s ease;
      opacity: 1;
    }
    .logoUnderline{
      width: 223px;
      height: 7px;
      display: block;
      margin: 0 auto;
      margin-top: 3px;
      margin-bottom: 36px;
      z-index: 9;
      transition: all .1s ease;
      opacity: 1;
    }
    .tabListOut{
      width: 100%;
      padding: 0 6px;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 77px 77px 92px 77px;
      grid-template-rows: 25px;
      grid-gap: 8px;
      z-index: 9;
      transition: all .1s ease;
      opacity: 1;
      justify-content: center;
      position: relative;
      top: 0;
      >div{
        font-family: MicrosoftYaHei;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        //background-size: 100% 100%;
        //background-image: url("~@/image/btnBg.png");
        background-repeat: no-repeat;
        background-position: -77px bottom;
        background-size: 77px 6px;
        background-image: url("~@/image/tabBtnBg.png");
        //&:hover{
        //  background-size: 100% 100%;
        //  background-image: url("~@/image/btnHover.png");
        //}
      }
      .btnActive{
        //background-size: 100% 100%;
        //background-image: url("~@/image/btnHover.png");
        background-size: 77px 6px;
        background-image: url("~@/image/tabBtnBg.png");
        background-position: center bottom;
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        transition: all .2s ease;
      }
    }
    .tabListOutfix{
      position: fixed;
      top: 0;
      width: 100%;
      transition: all .1s ease;
      background: #000020;
      height: 48px;
      align-content: center;
      justify-content: center;
    }
    .hideSclan{
      opacity: 0;
      height: 0;
      z-index: -1;
      transition: all .5s ease;
    }
  }
  .topFixedHide{
    //opacity: 0;
    //height: 0;
    //background: transparent;
  }
  .mainInfo{
    padding-top: 31px;
  }
  .botinfo{
    width: 100%;
    height: 147px;
    background-image: url('~@/image/botweb.png');
    background-size: 200% 50%;
    background-position: 0 100%;
    background-repeat: no-repeat;
    margin-top: 56px;
    .topTxt{
      width: 342px;
      display: block;
      margin: 0 auto;
    }
  }
  .popupOut{
    position: fixed;
    z-index: 9;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .89);
    display: flex;
    align-items: center;
    justify-content: center;
    .popupMain{
      width: 341px;
      height: 266px;
      height: 225px;
      position: relative;
      background-image: url("~@/image/popupBg.png");

      background-size: 100% 100%;
      padding-top: 25px;
      padding-left: 22px;
      padding-bottom: 18px;
      box-sizing: border-box;
      .topleft{
        position: absolute;
        width: 24px;
        height: 23px;
        left: 0;
        top: -1px;
        display: block;
        background-image: url("~@/image/paragraphBgAngle.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .escIcon{
        position: absolute;
        width: 29px;
        height: 29px;
        left: 0;
        right: 0;
        margin: auto;
        bottom: -45px;
        display: block;
        background-image: url("~@/image/popupEsc.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .mainData{
        display: grid;
        grid-template-columns: 19px 261px;
        grid-gap: 7px;
        >div{
          .leftLine{
            display: block;
            width: 1px;
            box-sizing: border-box;
            height: 81%;
            background-color: #ffffff;
            margin: 0 auto;
            margin-top: 8px;
          }
        }
        .rightView{
          .boxes{
            //margin-top: 29px;
            width: 262px;
            height: 36px;
            background-image: url("~@/image/paragraphTabBG.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: relative;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
            //text-indent: 5px;
            padding-left: 5px;
            box-sizing: border-box;
            //line-height: 36px;
            margin-bottom: 36px;
            display: flex;
            align-items: center;
            &::before{
              width: 19px;
              height: 23px;
              position: absolute;
              content: "";
              top: 7px;
              left: -26px;
              background-image: url("~@/image/localIcon.png");
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
            &::after{
              width: 20px;
              height: 20px;
              position: absolute;
              content: "";
              right: -26px;
              top: 8px;
              background-image: url("~@/image/arrows.png");
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
            &:nth-last-of-type(1) {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
